// extracted by mini-css-extract-plugin
export default {"mic":"ActiveMicIcon_mic__QRujh","pulse":"ActiveMicIcon_pulse__3CJGa","level":"ActiveMicIcon_level__bIHk9"};